module.exports = "/build/images/icons-public.853228f0.svg";